import ChromeExtensionPrivacy from 'components/Legal/ChromeExtensionPrivacy'
import { SnackbarProvider } from 'context/SnackbarProvider/SnackbarProvider'
import { WebsocketProvider } from 'context/Websocket/WebsocketProvider'
import { QuickChatProvider } from 'context/QuickChat'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import AuthCallback from './authentication/AuthCallback'
import AuthProvider from './authentication/AuthContext'
import ProtectedRoute from './authentication/ProtectedRoute'
import Token from './authentication/Token'
import { LayoutProvider } from './context/LayoutProvider/LayoutProvider'
import ProtectedApp from './ProtectedApp'
// import QueryDataDebugger from './api/queryFunctions/QueryDataDebugger'

const Main = () => {
  console.log('Main component mounted')
  return (
      <AuthProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          {/* <QueryDataDebugger /> */}
          <Routes>
            <Route path="/" element={<Token />} />
            <Route path="/callback" element={<AuthCallback />} />
            <Route path="/legal/chrome-extension-privacy" element={<ChromeExtensionPrivacy />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <LayoutProvider>
                    <SnackbarProvider>
                      <WebsocketProvider>
                        <QuickChatProvider>
                          <ProtectedApp />
                        </QuickChatProvider>
                      </WebsocketProvider>
                    </SnackbarProvider>
                  </LayoutProvider>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
  )
}

export default Main
